/**
 * Resource da reversa v2, servida pelo correios-services.
 *
 * @param {angular.resource.IResourceService} $resource
 * @param {string} URLAPICORREIOS
 */
export function CorreiosResource($resource, URLAPICORREIOS) {
  return $resource(
    URLAPICORREIOS + "/v1/reversas",
    {},
    {
      saveReverse: {
        method: "POST",
        url: URLAPICORREIOS + "/v1/reversas/",
      },
      getReverseDeliveryTypes: {
        method: "GET",
        url: URLAPICORREIOS + "/v1/reversas/tipos-entrega",
        params: {
          cepRemetente: "@cepRemetente",
          cepDestinatario: "@cepDestinatario",
        },
        isArray: true,
      },
    }
  );
}
